import pagination from '@iso/lib/helpers/pagination';

const model = {
    ...pagination('sales').model,
};

export default model;